import countriesBlacklist from 'config/countryBlacklist';

export const findBlacklistCountry = (country: string) => {
  const forbiddenCountry = countriesBlacklist[country];

  if (forbiddenCountry) {
    return true;
  } else {
    return false;
  }
};

export const checkUserCountry = () => {
  return new Promise((resolve, reject) => {
    const countryCodeExpression = /loc=([\w]{2})/;
    let countryCode: any;

    var xhr = new XMLHttpRequest();
    xhr.timeout = 3000;
    xhr.onreadystatechange = function () {
      if (this.readyState === 4) {
        if (this.status === 200) {
          countryCode = countryCodeExpression.exec(this.responseText);
          if (countryCode === null || countryCode[1] === '') {
            reject('Country code detection failed');
          }
          resolve(countryCode[1]);
        } else {
          reject(xhr.status);
        }
      }
    };
    xhr.ontimeout = function () {
      reject('timeout');
    };
    xhr.open('GET', 'https://www.cloudflare.com/cdn-cgi/trace', true);
    xhr.send();
  });
};
